// A Klaviyo flow link as the registry stores it: https://www.klaviyo.com/flow/<id>/edit, over TLS.
// The host has to be klaviyo.com, not merely contain it, since the link is shown to admins as the
// flow and satisfies the launch gate.
const klaviyoFlowIdFrom = url => {
  if (typeof url !== 'string' || !url.trim()) return null;
  let parsed;
  try {
    parsed = new URL(url.trim());
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:' || !/(^|\.)klaviyo\.com$/i.test(parsed.hostname)) return null;
  return parsed.pathname.match(/^\/flow\/([A-Za-z0-9]+)(\/|$)/)?.[1] || null;
};

const isKlaviyoFlowUrl = url => !!klaviyoFlowIdFrom(url);

module.exports = { klaviyoFlowIdFrom, isKlaviyoFlowUrl };
